import {
  faShapes,
  faSquare,
} from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import {
  type CustomResourceIconConfig,
  iconsByAtlasName,
} from './constants/icons';

export type { CustomResourceIconConfig } from './constants/icons';

export const genericCustomResourceIcon = faShapes;

/** Neutral placeholder for resources without a resolvable icon. */
export const fallbackCustomResourceIcon: CustomResourceIconConfig = {
  fontAwesome: faSquare,
};

// The system default categories (Parking spots, Lockers). Their template ids
// are org-agnostic constants seeded for every organization — see
// DEFAULT_CUSTOM_RESOURCE_TEMPLATES in the gateway's unified-search service.
const systemDefaultCategoryTypeIds = new Set([
  '6b57a4b6-8917-430e-ae26-c793228baa36', // Parking spots
  '0983afad-ccad-4418-a55e-f2da2aa00db0', // Lockers
]);

export const isSystemDefaultCategoryTypeId = (
  categoryTypeId: string | null | undefined
): boolean =>
  !!categoryTypeId && systemDefaultCategoryTypeIds.has(categoryTypeId);

/**
 * Resolves the icon for a search-service payload (a hit's `resourceIcon` or a
 * filter option's `icon`), both serving the kebab-cased atlas name.
 */
export const getCustomResourceIconForSearchHit = (hit: {
  resourceIcon?: string | null;
}): CustomResourceIconConfig =>
  (hit.resourceIcon && iconsByAtlasName.get(hit.resourceIcon.trim())) ||
  fallbackCustomResourceIcon;
